import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=da5b41e2&"
import script from "./SidebarContainer.vue?vue&type=script&lang=ts&"
export * from "./SidebarContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports